export enum clearanceStepAPIconfig {
    IndicationStatus = 8,
    DefaultValue = 0
}
export enum MessageId {
    QuoteFeedbackDefault = 3
}

export enum IndicationStatus {
    STATUS_INPROGRESS = "Indication - In Progress",
}

export enum IndicationInceptionStatus {
    STATUS_IDR = "Inception Date Referral",
    STATUS_IDRA = "Inception Date Referral Approved",
    STATUS_IDRD = "Inception Date Referral Declined"
}

export enum CompanyStatus{
    status1 = "Active",
    status2 = "Deactive"
}

export enum ToastType{
    Success = "success",
    Error = "error",
    Info = "info",
    Warning = "warning"
}

export enum ProductSlRemoveType{
    IsDeleted = 0
}

export enum MessageCenterRoleName{
    Broker = "Broker",
    UWAdmin = "UnderWriter Admin"
}

export enum PreferredReports{
    externalRequestId = '12345',
    subRequestId = '1'
}

export enum CompanyType{
    ADMIN_COMPANY = 43,
    BROKER_COMPANY = 44
}

export enum CountryType{
    US = 1,
    UK = 2
}

export const FILE_FORMAT: any = {
    ".pdf": "application/pdf",
    ".doc": "application/msword",
    ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".xls": "application/vnd.ms-excel",
    ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ".ppt": "application/vnd.ms-powerpoint",
    ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ".txt": "text/plain",
    ".csv": "text/csv",
    ".png": "image/png",
    ".jpeg": "image/jpeg",
    ".gif": "image/gif",
    ".svg": "image/svg+xml",
    ".zip": "application/zip",
    ".rar": "application/vnd.rar",
    ".html": "text/html",
    ".css": "text/css",
    ".js": "application/javascript"
};

export enum CreatePasswordIsReset{
    USER_EMAIL_UPDATE = 1,
    PASSWORD_LINK = 0 
}

export enum ResetPasswordIsCreateFlag{
    CREATE_PASSWORD = "1",
    RESET_PASSWORD = '0'
}

export const EQBD_HIGH_BPP_RESTRICTED_DESCRIPTIONS: string[] = [
    "Medical Offices/Clinics",
    "Independent Clinics (Chiropractors, Acupuncture)",
    "Nursing Homes/Assisted Living",
    "Pharmacies/Drug Stores",
    "Rehabilitation Centres",
    "Veterinary Services",
    "Healthcare and Wellness - Other"
];